import type { AbstractControl, ValidationErrors } from '@angular/forms';
import { isEmptyInputValue } from './shared';

// Beginning with '/' but not ending with '/'
const REGEXP = /^\/.*[^/]$/;

export class DataURIValidator {
  public static dataUri(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null; // don't validate empty values to allow optional controls
    }
    return REGEXP.test(control.value) ? null : { 'dataUri': true };
  }
}
